module.exports = __webpack_public_path__ + "img/followDoc_a.761c3c06.png";